(function() {
  // Fallback translations for elements without data-i18n-zh attribute
  const fallbackTranslations = {
    zh: {
      value_trust: '信任',
      value_quality: '品质',
      value_experience: '体验',
      value_value: '价值',
      value_service: '服务',
      tab_consumers: '消费者',
      tab_talents: '创意人才',
      tab_factories: '工厂',
      form_name: '您的姓名',
      form_email: '电子邮箱',
      form_message: '描述您的需求...',
      form_upload: '上传文件',
      form_submit: '提交需求'
    }
  };

  let currentLang = localStorage.getItem('ideashow_lang') || 'en';

  // Store original English content on page load
  function storeOriginalContent() {
    var elements = document.querySelectorAll('[data-i18n]');
    elements.forEach(function(el) {
      if (!el.hasAttribute('data-i18n-en')) {
        el.setAttribute('data-i18n-en', el.textContent);
      }
    });
  }

  // Language switcher
  const langBtn = document.querySelector('[data-lang-btn]');
  if (langBtn) {
    storeOriginalContent();
    updateLangButton();
    langBtn.addEventListener('click', function() {
      currentLang = currentLang === 'en' ? 'zh' : 'en';
      localStorage.setItem('ideashow_lang', currentLang);
      updateLangButton();
      updatePageLanguage();
    });
  }

  function updateLangButton() {
    if (!langBtn) return;
    var enText = langBtn.querySelector('[data-lang-text="en"]');
    var zhText = langBtn.querySelector('[data-lang-text="zh"]');
    if (currentLang === 'en') {
      enText.style.display = 'inline';
      zhText.style.display = 'none';
    } else {
      enText.style.display = 'none';
      zhText.style.display = 'inline';
    }
  }

  function updatePageLanguage() {
    var elements = document.querySelectorAll('[data-i18n]');
    elements.forEach(function(el) {
      var key = el.getAttribute('data-i18n');
      if (currentLang === 'zh') {
        // Try to get Chinese from data attribute first, then fallback
        var zhText = el.getAttribute('data-i18n-zh');
        if (zhText) {
          el.textContent = zhText;
        } else if (fallbackTranslations.zh[key]) {
          el.textContent = fallbackTranslations.zh[key];
        }
      } else {
        // Switch back to English - use stored original content
        var enText = el.getAttribute('data-i18n-en');
        if (enText) {
          el.textContent = enText;
        }
      }
    });
  }

  // Initialize language on page load
  storeOriginalContent();
  if (currentLang === 'zh') {
    updatePageLanguage();
  }

  // Tab functionality
  var tabs = document.querySelectorAll('.about-community__tab');
  var panels = document.querySelectorAll('.about-community__panel');

  tabs.forEach(function(tab) {
    tab.addEventListener('click', function() {
      var targetPanel = tab.getAttribute('data-tab');
      
      tabs.forEach(function(t) { t.classList.remove('about-community__tab--active'); });
      panels.forEach(function(p) { p.classList.remove('about-community__panel--active'); });
      
      tab.classList.add('about-community__tab--active');
      var panel = document.querySelector('[data-panel="' + targetPanel + '"]');
      if (panel) panel.classList.add('about-community__panel--active');
    });
  });

  // File upload handling
  var fileInput = document.getElementById('contact-file');
  var fileList = document.querySelector('[data-file-list]');

  if (fileInput && fileList) {
    fileInput.addEventListener('change', function(e) {
      fileList.innerHTML = '';
      Array.from(e.target.files).forEach(function(file) {
        var fileItem = document.createElement('div');
        fileItem.className = 'about-form__file-item';
        fileItem.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg><span>' + file.name + '</span><button type="button" class="about-form__file-remove" data-remove-file>&times;</button>';
        fileList.appendChild(fileItem);
      });
    });

    fileList.addEventListener('click', function(e) {
      if (e.target.hasAttribute('data-remove-file')) {
        e.target.parentElement.remove();
        fileInput.value = '';
      }
    });
  }
})();
